import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { trackAddToCart } from '../../lib/metaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  showLock?: boolean;
  subtext?: string;
}
const CHECKOUT_URL = 'https://pay.hotmart.com/S106088750H?checkoutMode=10';
export function Button({
  children,
  href = CHECKOUT_URL,
  showLock,
  subtext,
  className = '',
  ...props
}: ButtonProps) {
  const content = <div className="flex flex-col items-center justify-center gap-1" data-id="element-172">
      <div className="flex items-center gap-2 font-display text-xl tracking-wide uppercase" data-id="element-173">
        {showLock && <LockIcon className="w-5 h-5" data-id="element-174" />}
        {children}
      </div>
      {subtext && <span className="text-xs font-body font-medium text-midnight-deep/80 tracking-normal" data-id="element-175">
          {subtext}
        </span>}
    </div>;
  const baseClasses = 'block w-full max-w-md mx-auto bg-cyan-signal text-midnight-deep py-4 px-8 rounded-none hover:bg-cyan-signal/90 transition-colors border-b-4 border-cyan-signal/50 active:border-b-0 active:translate-y-1';
  if (href) {
    const isExternal = /^https?:\/\//.test(href);
    const isAnchor = href.startsWith('#');
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (isExternal) {
        trackAddToCart();
        return;
      }
      if (isAnchor) {
        const target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    };
    return <motion.a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={handleClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-176">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-177">
      {content}
    </motion.button>;
}